<script setup lang="ts">
import { inject, ref } from 'vue';
import { LegacyOrder, legacyOrderKey } from '@hantera/portal-app';
import LegacyPaymentDetails from '@/components/LegacyPaymentDetails/LegacyPaymentDetails.vue';


const order = inject(legacyOrderKey, ref<LegacyOrder>(<any>{}));

</script>

<template>
  <div class="legacy-order-view-payments">
    <LegacyPaymentDetails
      v-for="payments in order.payments"
      :key="payments.paymentId"
      :data="payments"
    />
  </div>
</template>

<style>
.legacy-order-view-payments {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 5px;
}
</style>